<template lang="pug">
	article#pagina
		Header
		Banner
		Inscrever
		Cronograma
		Oportunidade
		//- Duvida(v-if="step == 1" @next="step++")
		Formulario(v-if="step == 1" @next="step++")
		Agradecimento(v-if="step == 2")
		Footer
</template>

<script>

import Header from '@sections/ProuniHome/Header/Header.vue'
import Banner from '@sections/ProuniHome/Banner/Banner.vue'
import Inscrever from '@sections/ProuniHome/Inscrever/Inscrever.vue'
import Cronograma from '@sections/ProuniHome/Cronograma/Cronograma.vue'
import Oportunidade from '@sections/ProuniHome/Oportunidade/Oportunidade.vue'
import Duvida from '@sections/ProuniHome/Duvida/Duvida.vue'
import Formulario from '@sections/ProuniHome/Formulario/Formulario.vue'
import Agradecimento from '@sections/ProuniHome/Agradecimento/Agradecimento.vue'
import Footer from '@sections/ProuniHome/Footer/Footer.vue'

export default {
	name: "view-pagina",
	mixins: [
	],
	components: {
		Header,
		Banner,
		Inscrever,
		Cronograma,
		Oportunidade,
		Duvida,
		Formulario,
		Agradecimento,
		Footer
	},
	data() {
		return {
			step: 1
		}
	}
}
</script>

<style lang="stylus" scoped src="./Pagina.styl"></style>
